import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import 'rxjs';
import { Observable, Subject, throwError } from 'rxjs';
import { environment } from '../../environments/environment';
import { map } from 'rxjs/operators';
import { catchError } from 'rxjs/operators';
@Injectable({
  providedIn: 'root'
})
export class ContactoService {
  constructor(private http: HttpClient) { }

  send(data) {
    const header = new HttpHeaders({ 'Content-Type': 'application/json' });

    return this.http.post(environment.apiUrl + 'webContact', data)
      .pipe(map((res: any) => {
        return res;
      }));
  }
}
